const isAbsoluteUrl = (url: string): boolean =>
  url.startsWith('http://') || url.startsWith('https://');

const fetchAsDataUrl = async (url: string): Promise<string> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(
      `Failed to load virtual background image (HTTP ${response.status})`,
    );
  }

  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = () =>
      reject(reader.error ?? new Error('Failed to read image'));
    reader.readAsDataURL(blob);
  });
};

/**
 * Vonage's backgroundReplacement filter accepts same-origin URLs or data URLs.
 * Our file-service CDN URLs are cross-origin with no file extension, which it
 * rejects — fetch those and convert to a data URL. Bundled paths keep /v2.
 */
export const resolveVonageBackgroundImgUrl = (url: string): Promise<string> =>
  isAbsoluteUrl(url) ? fetchAsDataUrl(url) : Promise.resolve(`/v2${url}`);
